exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".reservation-welcome {\n  margin-top: 30px;\n  padding: 15px; }\n  .reservation-welcome .new_button {\n    align-self: center; }\n\n.row {\n  margin: 15px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap; }\n\n.column {\n  display: flex;\n  flex-direction: column;\n  flex-basis: 100%; }\n\n@media screen and (min-width: 800px) {\n  .column {\n    flex: 1; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/stylesheets/reservations/index.sass
// module id = 1375
// module chunks = 0